import { useQuery } from '@tanstack/react-query';
import type { UseQueryReturnType } from '../@types';
import { gqlClient } from '../clients';
import { graphql } from '../gql';
import type { Core_AcademicNamespacesQuery } from '../gql/graphql';
import { consumePrefetch } from '../prefetch/consume-prefetch';
import { ACADEMIC_NAMESPACES_OPERATION } from '../prefetch/operations';
import { queryClient } from '../query-client';
import { coreApiKeys } from './keys';

export type ReturnTypeFromUseCoreAcademicNamespace = UseQueryReturnType<
  typeof useCoreAcademicNamespace
>[number];

const coreAcademicNamespaces = graphql(/* GraphQL */ `
  query core_academicNamespaces {
    core_academicNamespaces {
      academicNamespaceId
      type
      name
      year
      description
      isActiveDefaultNamespace
      startDate
      endDate
    }
  }
`);

const coreAcademicNamespaceQuery = {
  queryKey: coreApiKeys.academicNamespaces.all(),
  queryFn: async () => {
    const prefetched = await consumePrefetch<Core_AcademicNamespacesQuery>(
      ACADEMIC_NAMESPACES_OPERATION,
    );
    const { core_academicNamespaces } =
      prefetched ?? (await gqlClient.request(coreAcademicNamespaces));
    return {
      core_academicNamespaces: core_academicNamespaces?.sort(
        (yearA, yearB) => yearB.year - yearA.year,
      ),
    };
  },
};

export function getCoreAcademicNamespace() {
  return queryClient.fetchQuery(coreAcademicNamespaceQuery);
}

export function useCoreAcademicNamespace() {
  return useQuery({
    ...coreAcademicNamespaceQuery,
    select: ({ core_academicNamespaces }) => core_academicNamespaces,
  });
}
